export const patternCity = options => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.id, label: option.nome })        
    });

    return array;
}

export const patternCityObmep = options => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.codigo, label: option.municipio })        
    });

    return array;
}

export const patternRegion = (options, withRJ04 = false) => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.sigla, label: option.sigla })
    });

    if (withRJ04)
        array.push({ value: "RJ04", label: "RJ04" });

    array.sort((a, b) => a.label.localeCompare(b.label));
    return array;
}

export default patternCity;